'use client';

import React from 'react';

interface SortOption {
  label: string;
  value: string;
  order: 'asc' | 'desc';
  metricId?: string;
}

interface SortValues {
  sort: string;
  order: 'asc' | 'desc';
  sort_metric?: string | null;
}

interface SortDropdownProps {
  sortOptions: SortOption[];
  handleSortChange: (
    field: string,
    order: 'asc' | 'desc',
    metricId?: string
  ) => void;
  sortValues: SortValues;
  strategyMetrics?: any;
  isOpen: boolean;
}

const SortDropdown: React.FC<SortDropdownProps> = ({
  sortOptions,
  handleSortChange,
  sortValues,
  strategyMetrics,
  isOpen,
}) => {
  if (!isOpen) return null;

  return (
    <div className="absolute top-full mt-1 right-0 w-auto min-w-[200px] whitespace-nowrap bg-white rounded-lg shadow-lg border border-neutral-200 py-1 max-h-60 overflow-y-auto z-50">
      {sortOptions.map((option, index) => {
        // Check if this option is currently active
        let isActive = false;
        if (option.value === 'date_added') {
          isActive =
            sortValues.sort === 'date_added' &&
            sortValues.order === option.order;
        } else if (option.value === 'metric' && option.metricId) {
          // For metrics, check if sort_metric matches any of this metric's display options AND order matches
          const metric = strategyMetrics?.results?.find(
            (m: any) => m.id.toString() === option.metricId
          );
          isActive =
            sortValues.sort === 'metric' &&
            sortValues.order === option.order &&
            metric?.display_options?.some(
              (opt: any) => opt.code === sortValues.sort_metric
            );
        }

        return (
          <div
            key={index}
            onClick={() =>
              handleSortChange(option.value, option.order, option.metricId)
            }
            className={`px-3 py-2 hover:bg-neutral-50 cursor-pointer text-sm font-normal flex items-center justify-between ${
              isActive ? 'bg-sky-50 text-sky-700' : 'text-text-secondary'
            }`}
          >
            <span>{option.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default SortDropdown;
